import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import type { TypographyProps } from '@mui/material/Typography';
import { PropsWithChildren } from 'react';

import { Sxable } from 'library/types';

type SectionTitleProps = {
	title: string;
	titleVariant?: TypographyProps['variant'];
	withDivider?: boolean;
} & Sxable;

export const SectionTitle = ({
	title,
	titleVariant = 'h3',
	children,
	withDivider = true,
	sx = [],
}: PropsWithChildren<SectionTitleProps>): React.JSX.Element => (
	<>
		<Box
			sx={[
				{
					display: 'flex',
					alignItems: 'center',
					minHeight: 40,
					gap: 1,
					mb: withDivider ? 0 : 2,
				},
				...(Array.isArray(sx) ? sx : [sx]),
			]}>
			<Typography
				variant={titleVariant}
				sx={{
					flex: 1,
				}}>
				{title}
			</Typography>
			{children}
		</Box>
		{withDivider && <Divider sx={{ my: 2 }} />}
	</>
);
